import Card from "components/card";
import React from "react";
import { MdDelete, MdEdit } from "react-icons/md";

import {
    createColumnHelper,
    flexRender,
    getCoreRowModel,
    getSortedRowModel,
    SortingState,
    useReactTable,
} from "@tanstack/react-table";
import { useRemoveFromStaff } from "modules/workspaces/api";

export type RowStaffObj = {
  id: string;
  name: string;
  email: string;
  role: string;
};

const columnHelper = createColumnHelper<RowStaffObj>();

// const columns = columnsDataCheck;
export default function ComplexTable(props: { tableData: any }) {
  const { tableData } = props;
  const [sorting, setSorting] = React.useState<SortingState>([]);
  let defaultData = tableData;
  const { mutate } = useRemoveFromStaff();

  const handleDelete = async (id: string) => {
    await mutate(id); // replace with your delete function
    setData(data.filter((member) => member.id !== id));
  };

  const columns = [
    columnHelper.accessor("name", {
      id: "name",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">NAME</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue()}
        </p>
      ),
    }),

    columnHelper.accessor("email", {
      id: "EMAIL",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">EMAIL</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue()}
        </p>
      ),
    }),
    columnHelper.accessor("role", {
      id: "role",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">ROLE</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue().charAt(0).toUpperCase() + info.getValue().slice(1)}
        </p>
      ),
    }),
    columnHelper.accessor("id", {
      id: "edit",
      header: () => (
        <p className="flex justify-end text-sm font-bold text-gray-600 dark:text-white">
          MODIFIER
        </p>
      ),
      cell: (id) => (
        <div className="flex items-end justify-end">
          <a
            className="cursor-pointer text-lg font-bold text-brand-500 dark:text-white"
            href={`/admin/staff/edit/${id.getValue()}`}
          >
            <MdEdit />
          </a>
        </div>
      ),
    }),
    columnHelper.accessor("id", {
      id: "delete",
      header: () => (
        <p className="flex justify-end text-sm font-bold text-gray-600 dark:text-white">
          SUPPRIMER
        </p>
      ),
      cell: (id) => (
        <div className="flex items-end justify-end">
          <p
            className="cursor-pointer text-lg font-bold text-red-500 dark:text-white"
            onClick={() => handleDelete(id.getValue())}
          >
            <MdDelete />
          </p>
        </div>
      ),
    }),
  ]; // eslint-disable-next-line
  const [data, setData] = React.useState(() => [...defaultData]);
  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: true,
  });

  return (
    <Card extra={"w-full h-full px-6 pb-6 sm:overflow-x-auto"}>
      <div className="relative flex items-center justify-between pt-4">
        <div className="text-xl font-bold text-navy-700 dark:text-white">
          Workspaces
        </div>
        <a
          className="cursor-pointer rounded-full bg-brand-500 p-0.5 text-white"
          href="/admin/staff/create"
        >
          <svg
            className="h-8 w-8 cursor-pointer"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
            />
          </svg>
        </a>
      </div>

      <div className="mt-8 overflow-x-scroll xl:overflow-x-hidden">
        <table className="w-full">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id} className="!border-px !border-gray-400">
                {headerGroup.headers.map((header) => {
                  return (
                    <th
                      key={header.id}
                      colSpan={header.colSpan}
                      onClick={header.column.getToggleSortingHandler()}
                      className="cursor-pointer border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start"
                    >
                      <div className="items-center justify-between text-xs text-gray-200">
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                        {{
                          asc: "",
                          desc: "",
                        }[header.column.getIsSorted() as string] ?? null}
                      </div>
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>
          <tbody>
            {table
              .getRowModel()
              .rows
              .map((row) => {
                return (
                  <tr key={row.id}>
                    {row.getVisibleCells().map((cell) => {
                      return (
                        <td
                          key={cell.id}
                          className="min-w-[150px] border-white/0 py-3  pr-4"
                        >
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                          )}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
